import { Space } from 'antd';
import React from 'react';
import appStore from '../../assets/app-store-badge.svg';
import playStore from '../../assets/google-play-badge.svg';
import { useIntercom } from '../../hooks/use_intercom';
import { ContentWrapper } from '../content_wrapper/content_wrapper';
import { SpanLink } from '../span_link/span_link';
import styles from './livestream_faqs.less';

export const LivestreamFaqs = () => {
  const intercom = useIntercom();
  return (
    <>
      <section className={styles.bottom}>
        <ContentWrapper>
          <h2>Frequently Asked Questions</h2>
          <div className={styles.faqs}>
            <div className={styles.faq}>
              <h3>What is Omnia Live Shopping?</h3>
              <p>
                Omnia Live Shopping offers a unique tackle buying experience where you can shop for
                products while watching live fishing events. Omnia will identify the techniques and
                gear being used at the event in real time and provide shopping links alongside the
                stream. You can add products to your cart without leaving the stream.
              </p>
            </div>

            <div className={styles.faq}>
              <h3>How do I watch the live stream?</h3>
              <p>
                Return to this page during the live event (once the event has started) to start
                watching the stream. You can watch the stream from your personal computer or phone -
                on the Omnia website or the Omnia Fishing app, available for{' '}
                <a href="https://omnia.fish/apple">iOS</a> and{' '}
                <a href="https://omnia.fish/google">Android.</a>
              </p>

              <Space size="middle">
                <a href="https://omnia.fish/apple">
                  <img src={appStore} alt="Download on the App Store" width={177} />
                </a>
                <a href="https://omnia.fish/google">
                  <img src={playStore} alt="Get it on Google Play" width={200} />
                </a>
              </Space>
            </div>

            <div className={styles.faq}>
              <h3>How do I shop for products?</h3>
              <ol>
                <li>Start the live stream during the live event.</li>
                <li>
                  Products and other recommendations will appear alongside the event coverage.
                </li>
                <li>Tap items to add them to your cart.</li>
                <li>Keeping watching (you don’t need to check out right away).</li>
                <li>
                  Check out when you’re ready. Logged in users will be able to check out fastest.
                </li>
                <li>Orders in by 1pm Central ship same day.</li>
              </ol>
            </div>

            <div className={styles.faq}>
              <h3>Where can I get help or support?</h3>
              <p>
                Need help during the live stream?{' '}
                <SpanLink
                  onClick={() => {
                    intercom.show();
                  }}
                >
                  Start a chat
                </SpanLink>{' '}
                with the Omnia team and we’ll get you on the right track.
              </p>
            </div>
          </div>
        </ContentWrapper>
      </section>
    </>
  );
};
